import { combineReducers } from 'redux';
import pageLayout from './page-layout';
import itemForm from './item-form';
import viewItem from './view-item';
import itemSkuLookup from './item-sku-lookup';
import adjustItemForm from './adjust-item-form';
import search from './search';
import searchOptions from './search-options';
import auditLogSearch from './audit-log-search';
import reports from './reports';
import editTagModal from './edit-tag-model';
import importItemsResult from './import-items-result';
import importItemsQuantityResult from './import-items-qantity-result';
import onHoldReservations from './on-hold-reservations';

export default combineReducers({
  pageLayout,
  itemForm,
  viewItem,
  itemSkuLookup,
  adjustItemForm,
  search,
  searchOptions,
  auditLogSearch,
  reports,
  editTagModal,
  importItemsResult,
  importItemsQuantityResult,
  onHoldReservations
});
